import { EmptyCircle } from '@/components/ui';
import { cn } from '@/lib/utils';
import { ICON_TONE_CLASSES, NOTIFICATION_TYPE_META, type NotificationType } from '@/lib/notifications/notification-types';

export interface NotificationIconProps {
  type: NotificationType;
  /** `meta.marketImageUrl` for market types — falls back to a neutral circle. */
  imageUrl?: string;
  className?: string;
}

/**
 * The leading circle on a notification row. Market types show the market image
 * (`meta.marketImageUrl`) and fall back to a neutral circle when it's missing
 * (the data team denormalises it at send-time — graceful when absent). Account
 * and admin-broadcast types show a tinted type icon instead.
 */
export function NotificationIcon({ type, imageUrl, className }: NotificationIconProps) {
  const meta = NOTIFICATION_TYPE_META[type];

  if (meta?.isMarket) {
    return <EmptyCircle src={imageUrl} alt="" className={cn('size-10 shrink-0', className)} />;
  }

  const Icon = meta?.icon;
  return (
    <span
      aria-hidden
      className={cn(
        'flex size-10 shrink-0 items-center justify-center rounded-full',
        ICON_TONE_CLASSES[meta?.tone ?? 'muted'],
        className,
      )}
    >
      {Icon && <Icon className="size-5" />}
    </span>
  );
}
